import config from '../config';

export function fetchEmployees(date = false) {
  let api = `${config.api}/employees?token=${config.token}`;

  if (date) {
    api += `&availability_date=${date}`;
  }

  return fetch(api)
    .then(res => res.json());
}



// WEBPACK FOOTER //
// ./src/api/employees.js